import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import PanelComponent from '../components/shared_components/PanelComponent';
import CalculationFormComponent from '../components/calculation/calculation_form/CalculationFormComponent';
import LoanpartOverviewComponent from '../components/calculation/calculation_output/LoanpartOverviewComponent';
import LoanpartSummaryComponent from '../components/calculation/calculation_output/LoanpartSummaryComponent';
import LoanpartOverviewTabsComponent from '../components/calculation/calculation_output/LoanpartOverviewTabsComponent';
import LoaderComponent from '../components/shared_components/LoaderComponent';
import PrimaryButton from '../components/shared_components/buttons/PrimaryButtonComponent';
import LoanpartOverviewHeaderComponent from '../components/calculation/calculation_output/LoanpartOverviewHeaderComponent';
import MainData from '../stores/MainStore';
import ErrorAlertComponent from '../components/shared_components/ErrorAlertComponent';

@observer
class CalculationContainer extends React.Component {
  static goToLocation(e) {
    window.open(e.target.href, '_blank');
  }

  constructor(props) {
    super(props);

    this.startDownloadPdf = this.startDownloadPdf.bind(this);
    CalculationContainer.goToLocation = CalculationContainer.goToLocation.bind(this);
  }

  componentWillMount() {
    this.props.CalculationOutputData.calculationResponse = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  startDownloadPdf(e) {
    e.preventDefault();

    this.props.CalculationOutputData.setTextDownloadReport('Downloaden...');

    this.props.CalculationOutputData.downloadPdf();
  }

  render() {
    const {
      calculationResponseLoading,
      activeLoanpartOverviewTabId,
      allTabs,
      textDownloadReport,
      responseError,
    } = this.props.CalculationOutputData;

    const activeTabName = allTabs.find(tab => tab.id === activeLoanpartOverviewTabId).name;
    const showCalculationFormComponent = true;
    const showOutput = _.has(this.props.CalculationOutputData.calculationResponse, 'data') &&
      !calculationResponseLoading;
    const advisorEndpoint = this.props.CalculationFormData.advisorEndpointsById;

    return (
      <div className="calculation-container">
        <div className="row calculation-container__header">
          <h1>Bereken uw maandlasten</h1>
          <h1>Duidelijk en overzichtelijk</h1>
        </div>

        <PanelComponent
          show={showCalculationFormComponent}
          classNames={'row calculation-container--calculation-form-panel'}
        >

          <CalculationFormComponent />

        </PanelComponent>

        <LoaderComponent
          show={calculationResponseLoading}
        />

        <PanelComponent
          classNames={'row calculation-container--calculation-output-panel'}
          show={showOutput}
        >
          <LoanpartSummaryComponent />
          <LoanpartOverviewTabsComponent />
          <LoanpartOverviewHeaderComponent
            activeTabName={activeTabName}
          />
          <LoanpartOverviewComponent />

          <div className="calculation-footer-container">
            <ErrorAlertComponent
              show={responseError}
              responseError={responseError}
            />

            <div className="advisor-search-btn">
              <div className="columns medium-15 float-right">
                <PrimaryButton
                  show={showOutput && advisorEndpoint}
                  onClickHandler={CalculationContainer.goToLocation}
                  href={advisorEndpoint || ''}
                  text={'Zoek adviseur'}
                />
              </div>
            </div>
            <div className="columns medium-15 float-right">
              <PrimaryButton
                show={showOutput}
                onClickHandler={this.startDownloadPdf}
                disabled={!_.isEmpty(textDownloadReport)}
                href="#"
                text={textDownloadReport || 'Download rapport'}
              />
            </div>
          </div>
        </PanelComponent>
      </div>
    );
  }
}

CalculationContainer.propTypes = {
  CalculationFormData: PropTypes.shape({
    responseError: PropTypes.string,
    showNhgAlertInfo: PropTypes.bool,
    getNhgRegulations: PropTypes.func,
    mortgageForm: PropTypes.shape({
      labelId: PropTypes.number,
    }),
    advisorEndpointsById: PropTypes.string,
  }),
  MainData: PropTypes.shape({
    isApp: PropTypes.bool,
  }),
  CalculationOutputData: PropTypes.shape({
    activeLoanpartOverviewTabId: PropTypes.string,
    allTabs: PropTypes.arrayOf(PropTypes.shape({})),
    calculationResponse: PropTypes.shape({}),
    calculationResponseLoading: PropTypes.bool,
    downloadPdf: PropTypes.func,
    responseError: PropTypes.string,
    textDownloadReport: PropTypes.string,
    setTextDownloadReport: PropTypes.func,
  }),
};

CalculationContainer.defaultProps = {
  MainData: {
    isApp: true,
  },
  CalculationFormData: {
    mortgageForm: {},
  },
  CalculationOutputData: PropTypes.shape({
    allTabs: [],
    activeLoanpartOverviewTabId: '',
    calculationResponse: {},
    calculationResponseLoading: false,
    responseError: '',
  }),
};

export default inject('CalculationOutputData', 'MainData', 'CalculationFormData')(
  CalculationContainer);
